
import { useEffect, useState } from 'react';
import { usePreferences } from "@react-admin/ra-preferences";
const jwt = require("jsonwebtoken");

export const REACT_APP_METABASE_URL = process.env.REACT_APP_METABASE_URL as string;
export const REACT_APP_METABASE_KEY = process.env.REACT_APP_METABASE_KEY as string;

export const ProjectStats = ({ id, hasCustomDashboard, customDashboardId }) => {
    const [token, setToken] = useState(null);
    const [mode, setMode] = useState(null);
    const [theme] = usePreferences('theme', 'light');
    useEffect(() => {
        setMode(theme === "light" ? null : "night");
        const payload = {
            resource: { dashboard: (hasCustomDashboard ? customDashboardId : 3) },
            params: {
                "projet": [id]
            },
            exp: Math.round(Date.now() / 1000) + (60 * 60) // 60 minute expiration
        };
        setToken(jwt.sign(payload, REACT_APP_METABASE_KEY, { algorithm: 'HS256' }));
    }, [id, theme, hasCustomDashboard, customDashboardId])
    return <iframe
        src={`${REACT_APP_METABASE_URL}/embed/dashboard/${token}#theme=${mode}&bordered=false&titled=false`}
        className="stats"
        title="resources.project.stats.title"
    ></iframe>
};